import type EnType from '../en-US/app';

export default {
  'app.default.title': '{appName} - Documentación de API',
  'app.default.keywords':
    '{appNamePrefix}Diseño de API, Especificación de API, Prueba de API, Documentación de API, Mock de API',
  'app.default.description':
    '{appNamePrefix}Diseñar. Depurar. Probar. Documentar. Mock. Construir APIs Más Rápido y Juntos.',
} satisfies typeof EnType;
